import { render, staticRenderFns } from "./livingSetting.vue?vue&type=template&id=85ee3cdc&scoped=true&"
import script from "./livingSetting.vue?vue&type=script&lang=js&"
export * from "./livingSetting.vue?vue&type=script&lang=js&"
import style0 from "./livingSetting.vue?vue&type=style&index=0&id=85ee3cdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ee3cdc",
  null
  
)

export default component.exports